import { config, library, dom } from "@fortawesome/fontawesome-svg-core"
import {
  faArrowDownShortWide,
  faArrowDownWideShort,
  faBold,
  faBook,
  faCalendar,
  faCircleCheck,
  faCircleExclamation,
  faCircleInfo,
  faCircleXmark,
  faClock,
  faCreditCard,
  faDroplet,
  faFloppyDisk,
  faItalic,
  faKey,
  faLink,
  faList,
  faPenToSquare,
  faPerson,
  faPersonDress,
  faRightFromBracket,
  faSpinner,
  faStar,
  faSuitcase,
  faTrash,
  faTriangleExclamation,
  faUpRightFromSquare,
  faUser,
  faUserPlus,
  faXmark
} from "@fortawesome/free-solid-svg-icons"

config.mutateApproach = "sync"
library.add(
  faArrowDownShortWide,
  faArrowDownWideShort,
  faBold,
  faBook,
  faCalendar,
  faCircleCheck,
  faCircleExclamation,
  faCircleInfo,
  faCircleXmark,
  faClock,
  faCreditCard,
  faDroplet,
  faFloppyDisk,
  faItalic,
  faKey,
  faLink,
  faList,
  faPenToSquare,
  faPerson,
  faPersonDress,
  faRightFromBracket,
  faSpinner,
  faStar,
  faSuitcase,
  faTrash,
  faTriangleExclamation,
  faUpRightFromSquare,
  faUser,
  faUserPlus,
  faXmark
)
dom.watch()
